import React, { useEffect, useState } from "react";
import "aos/dist/aos.css";
import "../assets/css/main.css";
import "../assets/vendor/bootstrap/css/bootstrap.min.css";
import "../assets/vendor/bootstrap-icons/bootstrap-icons.css";
import "../assets/vendor/glightbox/css/glightbox.min.css";
import "../assets/vendor/swiper/swiper-bundle.min.css";
import heroImage from "../assets/img/HovigV3.png";
import AnimatedHeadline from "./AnimatedHeadline";
import { useTranslation } from "react-i18next";

function Hero() {
  const [showButton, setShowButton] = useState(true);
  const { t } = useTranslation();
  const scrollToAbout = () => {
    const aboutSection = document.getElementById("about2");
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    
    
    const handleScroll = () => {
      setShowButton(window.scrollY === 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section id="hero" className="hero section dark-background">
      <img src={heroImage} alt="Hero" data-aos="fade-in" />
      <div className="container d-flex flex-column align-items-center justify-content-center text-center" data-aos="fade-up" data-aos-delay="100">
        <h1>Hovig ABECHIAN</h1>
        <div className="headline-separator"></div>
        <AnimatedHeadline />
      </div>

      {/* Barre sociale en bas à gauche */}
      <div className="social-bar">
        <div className="vertical-line"></div>
        <a href="https://www.instagram.com/hovigabechian/?hl=fr" target="_blank" rel="noopener noreferrer">
          <i className="bi bi-instagram"></i>
        </a>
        <a href="https://www.linkedin.com/in/hovig-abechian-211a75123/" target="_blank" rel="noopener noreferrer">
          <i className="bi bi-linkedin"></i>
        </a>
        <a href="https://www.facebook.com/hovig.abechian" target="_blank" rel="noopener noreferrer">
          <i className="bi bi-facebook"></i>
        </a>
      </div>

      {/* Bouton Learn More */}
      {showButton && (
        <div className="learn-more-btn" onClick={scrollToAbout}>
          <span>{t("HeroLearnMore")}</span>
          <i className="bi bi-arrow-down"></i>
        </div>
      )}
    </section>
  );
}

export default Hero;
